<div class="bottomSheetContainer" (click)="dimiss()">
  <div class="button">
    <div class="btn-ln">
      <div class="line">

      </div>
      <h4>Participantes</h4>
    </div>
  </div>
  <div class="container">
    <div class="card">
      <div class="body1">
        <div class="menssge-cabecera">
          @if (play.simulacion && play.simulacion.premio>0) {
            <p>¡Premiado!</p>
          }
          @if (play.simulacion && play.simulacion.premio==0) {
            <p class="sinPremioColor">Vaya...</p>
          }
          @if (!play.simulacion) {
            <p>No sorteado</p>
          }
        </div>

        <div class="titulo">
          @if (play.simulacion && play.simulacion.premio>0) {
            <h4>{{play.simulacion.premio | currency:'EUR'}}
            </h4>
          }
          @if (play.simulacion && play.simulacion.premio==0) {
            <h4 class="sinPremioColor sinPremioColor-dark">
            Sin premio</h4>
          }
          @if (!play.simulacion) {
            <h4>0.00 €</h4>
          }
        </div>

        <div class="message">
          @if (play.simulacion && play.simulacion.premio>0) {
            <p>{{totalPorIntgrante | currency:'EUR'}} cada
            uno</p>
          }
          @if (!play.simulacion) {
            <p>Ya queda menos</p>
          }
          @if (play.simulacion && play.simulacion.premio==0) {
            <p>Vuelva a intentarlo</p>
          }
        </div>
      </div>

      <div class="body2">
        @if (play.simulacion && play.simulacion.premio>0) {
          <img src="/assets/images/bootomSheet/premiado.svg"
            alt="img" />
        }
        @if (!play.simulacion) {
          <img src="/assets/images/bootomSheet/espera.svg" alt="img" />
        }
      </div>
    </div>

    <ul class="lista">
      <ng-scrollbar>
        @for (participante of participantes; track participante) {
          <li class="list-item">
            <div class="icon">
              <div class="letter">
                @if (grupo) {
                  {{getFirstLetter(participante.nombre)}}
                } @else {
                  {{getFirstLetter(participante.nombre_invitado)}}
                }
              </div>
            </div>
            <div class="content">
              <p>
                @if (grupo) {
                  {{participante.nombre+" "+participante.apellido_1}}
                } @else {
                  {{participante.nombre_invitado}}
                }
              </p>
            </div>
            <div class="currecy">
              <p>{{totalPorIntgrante | currency:'EUR'}}</p>
            </div>
          </li>
        }
      </ng-scrollbar>
    </ul>
  </div>
</div>